module.exports = __webpack_public_path__ + "img/checkApp3.55968bad.png";